import $ from 'jquery';

export default class WCArchiveOrderBy {
    constructor() {
        this.sortSelectParent = document.querySelector('.jsWooOrderbyParent');
        this.sortSelect = document.querySelector('.jsWooOrderby');

        if (this.sortSelect) {
            this.events();
        }
    }

    events() {
        if (this.sortSelect) {
            this.initializeSelectField();
        }
    }

    initializeSelectField() {
        const select = this.sortSelect;

        if (this.sortSelectParent) {
            $(select).select2({
                minimumResultsForSearch: -1,
                dropdownParent: $(this.sortSelectParent),
            });
        } else {
            $(select).select2({
                minimumResultsForSearch: -1,
            });
        }
    }
}
